import React, { useEffect, useState } from 'react';
import Prompt from 'react-router-dom/Prompt';
import { useBeforeunload } from 'react-beforeunload';

import Disclaimer from './Disclaimer';
import EmployeeInformation from './EmployeeInformation';
import BidInformation from './BidInformation';
import VacationInformation from './VacationInformation';

import urlHelper from '../../utils/urlHelper';
import commonFunctions from '../../utils/commonFunctions';
import asyncRequest from '../../utils/asyncRequest';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Grey from '@material-ui/core/colors/grey';
import Red from '@material-ui/core/colors/red';
import { makeStyles } from '@material-ui/core/styles';

import _concat from 'lodash/concat';
import _remove from 'lodash/remove';
import _each from 'lodash/each';
import _sortBy from 'lodash/sortBy';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import CountdownTimer from '../CountdownTimer';
import { YearlyProvider } from './YearlyContext';
const useStyles = makeStyles((theme) => ({
    card: {
        margin: theme.spacing(2),
    },
    title: {
        fontSize: '1.7em',
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: Grey[500],
    },
    loader: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        zIndex: '9999',
    },
    marginBottom: {
        marginBottom: theme.spacing(2),
    },
    closed: {
        color: Red[500],
        float: 'right',
    }
}));

function Yearly() {
    const [name] = useState(commonFunctions.getUserName());
    const [employeeId] = useState(commonFunctions.getUserEmployeeId());
    const [seniorityDate, setSeniorityDate] = useState('');
    const [domicile, setDomicile] = useState('');
    const [periodsBidding, setPeriodsBidding] = useState('');
    const [group, setGroup] = useState('');
    const [controlId, setControlId] = useState('');
    const [accrualId, setAccrualId] = useState('');
    const [daysToBid, setDaysToBid] = useState('');
    const [vacation1, setVacation1] = useState([]);
    const [vacation2, setVacation2] = useState([]);
    const [vacation3, setVacation3] = useState([]);
    const [vacation4, setVacation4] = useState([]);
    const [vacation5, setVacation5] = useState([]);

    const [isUpdating, setIsUpdating] = useState(true);
    const [slotsAvailable, setSlotsAvailable] = useState([]);

    const [openSaveDialog, setOpen_SaveDialog] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogButtonText, setDialogButtonText] = useState('');

    const [showLoader, setShowLoader] = useState(true);
    const [biddingClosed, setBiddingClosed] = useState(false); //is the bidding period open? is it round 1-3?
    const [isDirty, setIsDirty] = useState(false);
    const [freezeBidding, setFreezeBidding] = useState(false); //is the bidding period open for this person? perhaps their round has already been awarded, show bids as readonly
    const isDirtyMessage = 'You have unsaved changes. Are you sure you want to leave?';
    const [endTimeMoment,setEndTimeMoment] = useState(moment());
    const classes = useStyles();

    useBeforeunload(() => ""); // used default browser message in case user tries to close browser

    // biddingYear: for yearly bidding this will ALWAYS be the current year + 1
    // control records and all bids will be for biddingYear
    const biddingYear = new Date().getFullYear() + 1;

    useEffect(() => {
        setIsUpdating(false); 
    }, [vacation1, vacation2, vacation3, vacation4, vacation5]);

    useEffect(() => {
        //1. go get control record info, (error if null or not correct format)
        // if bidding is open, THEN
        //2. go get employee information: accrual, faMaster info, and any existing yearly bids
        // this should only run once upon load of page
        
        const url1 = urlHelper.getYearlyControlRecordInfo(biddingYear);
        const url2 = urlHelper.getEmployeeInfo(employeeId, biddingYear);
        const url3 = urlHelper.getAvailableSlots(employeeId, biddingYear);
        
        let biddingClosedTemp = false;
        let round = 0;
        let biddingPeriods = [];
        asyncRequest.get(url1)  //get the control record info, should return 4 control records for the year
        .then(function(response1) {
            let ctrlId = 0;
            if (response1 == null || response1.data === 'Control records error'){  //was the control record data found?
                handleOpenDialog('Yearly Bidding is Closed', 'No data found for ' + biddingYear, 'Ok');
                biddingClosedTemp = true;
            } else {
                console.log('* Pre checks');
                biddingPeriods = response1.data;
                const isLocalTimeBeforeStart = isLocalTimeBefore(response1.data[0].startTime) ;
                const isLocalTimeAfterEnd = isLocalTimeAfter(response1.data[2].endTime);
                
                const localTimeForDisplay = getLocalTimeForDisplay(response1.data[0].startTime);

                //bidding is only open from round 1 start time to round 3 end time, Is the bidding period open?
                if (isLocalTimeBeforeStart) {  //round 1
                    handleOpenDialog('Yearly Bidding is Closed', 'Yearly Bidding will open for ' + biddingYear + ' on ' + localTimeForDisplay, 'Ok');
                    biddingClosedTemp = true;
                } else if (isLocalTimeAfterEnd) {  //round 3
                    handleOpenDialog('Yearly Bidding is Closed', 'Bidding has closed for ' + biddingYear, 'Ok');
                    biddingClosedTemp = true;
                }
            }
            if (!biddingClosedTemp) {
                //need to find the correct control Id out of the 4 (which one falls within the current date range)
                console.log('* control record check');
                response1.data.forEach((controlRecord, index) => {
                    console.log('* Check' + index);
                    //look for the control record that is within the start and end time frame
                    if (isLocalTimeAfter(controlRecord.startTime) && isLocalTimeBefore(controlRecord.endTime)) {
                        if (controlRecord.isActive) {
                            ctrlId = controlRecord.id;
                            round = controlRecord.round;
                            const endTime =  moment.tz(controlRecord.endTime,'America/Chicago');
                            setEndTimeMoment(endTime);
                        }
                    }
                });
                setControlId(ctrlId);  //will default of 0 if no active control record found!
                if (ctrlId === 0) {
                    handleOpenDialog('Yearly Bidding is Closed', 'There is no active round', 'Ok');
                    biddingClosedTemp = true;
                }
            }
            return asyncRequest.get(url2);
        })
        .then(function(response2) {  //get the employee info and bids
            if ((response2 == null || response2.data === 'Error loading employee infomation' || response2.data.accrualId == null)) {  //problem getting employee info
                if (!biddingClosedTemp){
                    handleOpenDialog('Error', 'Missing employee info. Please contact the Help Desk.', 'Ok');
                }
            } else {  //we have employee info so load it up on UI
                setAccrualId(response2.data.accrualId);
                setDaysToBid(response2.data.daysToBid);
                setPeriodsBidding(response2.data.periodsBidding);
                setSeniorityDate(commonFunctions.formatDate_Date(response2.data.seniorityDate));
                setDomicile(response2.data.domicile);
                setGroup(response2.data.group);
                setBiddingClosed(biddingClosedTemp);
                if (response2.data.vacationBids) {
                    loadBidsToUI(response2.data.vacationBids);
                }
                //do not allow the FA to edit bids if the active round > than the FAs round assigned in their accrual (their round is done)
                if (round > response2.data.group){
                    if (!biddingClosedTemp) { //if bidding is already closed from above, show that dialog message instead
                        handleOpenDialog('Yearly Bidding is Closed', 'Bidding has closed for group ' + response2.data.group +'. Your bids can no longer be changed.', 'Ok');
                        setFreezeBidding(true);  //put any bids in readonly view
                    }
                }
                if (round < response2.data.group){
                    if (!biddingClosedTemp) { //if bidding is already closed from above, show that dialog message instead
                        const usersGroupIndex = response2.data.group;
                        const usersGroupEndTime = biddingPeriods[usersGroupIndex-1].startTime;
                        handleOpenDialog(`Bidding is open for group ${round}.`,`Your group (${response2.data.group}) will open for bidding on ${getLocalTimeForDisplay(usersGroupEndTime)}, you can still submit bids at this time.`, 'Ok');
                    }
                }
            }
            if (biddingClosedTemp){  //if bidding is closed in general, put any bids in readonly view
                setFreezeBidding(true);
                setBiddingClosed(true);
            }
            return asyncRequest.get(url3);
        })
        .then(function(response3) {
            if (response3 != null && response3.data) {
                //set slots available here so we can use it in validation upon entering dates for bids
                setSlotsAvailable(response3.data);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log('ERROR', error);
            handleOpenDialog('Error', error.message, 'Ok');
            setShowLoader(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getLocalTimeForDisplay = (startTime) => {
        if (startTime === null) {return 'N/A';}
        const localTime = moment.tz(startTime, 'America/Chicago');
        return moment.tz(localTime, 'America/Chicago').local().format('MM/DD/YY hh:mm A');
    };    
    const isLocalTimeBefore = (dateString) => {
        const userTime = moment.tz(moment(), 'America/Chicago');
        const date = moment.tz(dateString, 'America/Chicago');
        const isBefore = userTime.isBefore(date, 'minute');
        console.log('* userTime: ' + userTime.format('MM/DD/YY hh:mm A') + ' date: ' + date.format('MM/DD/YY hh:mm A'));
        console.log('* user isBefore: ' + isBefore);
        return isBefore;
    }
    const isLocalTimeAfter = (dateString) => {
        const userTime = moment.tz(moment(), 'America/Chicago');
        const date = moment.tz(dateString, 'America/Chicago');
        const isAfter = userTime.isAfter(date, 'minute');
        console.log('* userTime: ' + userTime.format('MM/DD/YY hh:mm A') + ' date: ' + date.format('MM/DD/YY hh:mm A'));
        console.log('* user isAfter: ' + isAfter);
        return isAfter;
    }
    const handleYearlyVacAdd = (item) => {
        switch(item.vacationNumber) {
            case 1:
                item.rank = vacation1.length + 1;
                setVacation1(_concat(vacation1, item));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 2:
                item.rank = vacation2.length + 1;
                setVacation2(_concat(vacation2, item));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 3:
                item.rank = vacation3.length + 1;
                setVacation3(_concat(vacation3, item));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 4:
                item.rank = vacation4.length + 1;
                setVacation4(_concat(vacation4, item));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 5:
                item.rank = vacation5.length + 1;
                setVacation5(_concat(vacation5, item));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            default:
                break;
        };
    };

    const handleYearlyVacReorder = (vacation, vacationNumber) => {
        setIsDirty(true);
        switch(vacationNumber){
            case 1:
                setVacation1(vacation);
                break;
            case 2:
                setVacation2(vacation);
                break;
            case 3:
                setVacation3(vacation);
                break;
            case 4:
                setVacation4(vacation);
                break;
            case 5:
                setVacation5(vacation);
                break;
            default:
                break;
        };
    };

    const handleSaveClick = () => {
        if(isDirty) {
            setOpen_SaveDialog(true);
        } else {
            handleOpenDialog('No changes made. Nothing to submit!', '', 'Ok');
        }
    };

    const remove = (vacationGroup, itemId) => {
        //remove the item from the vacation group
        let temp = _remove(vacationGroup, function(i) { return i.id !== itemId; });
        
        //sort the ranks
        let sorted = _sortBy(temp, ['rank']);
        
        // re number the ranks
        _each(sorted, function(item, index){
            item.rank = index + 1;
        });

        return sorted;
    };

    const handleYearlyVacRemove = (itemId, vacationNumber) => {
        switch(vacationNumber) {
            case 1:
                setVacation1(remove(vacation1, itemId));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 2:
                setVacation2(remove(vacation2, itemId));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 3:;
                setVacation3(remove(vacation3, itemId));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 4:
                setVacation4(remove(vacation4, itemId));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            case 5:
                setVacation5(remove(vacation5, itemId));
                setIsUpdating(true);
                setIsDirty(true);
                break;
            default:
                break;
        };
    };

    const handleOpenDialog = (title, message, buttonText) => {
        setDialogTitle(title);
        setDialogMessage(message);
        setDialogButtonText(buttonText);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setDialogTitle('');
        setDialogMessage('');
        setDialogButtonText('');
        setOpenDialog(false);
    };

    const handleClose_SaveDialog = () => {
        setOpen_SaveDialog(false);
    };
    const handleTimerComplete = (timerRemaning) => {
        if (timerRemaning.asMilliseconds() <= 0) {
            setBiddingClosed(true);
        }
    }
    const handleSave = () => {
        setOpen_SaveDialog(false);
        setShowLoader(true);
        const vacationBids = _concat(vacation1, vacation2, vacation3, vacation4, vacation5);
        const saveData = { employeeId, biddingYear, controlId, accrualId, domicile, vacationBids };
        
        asyncRequest.post(urlHelper.saveYearlyBids(), saveData)
        .then((response) => {
            setShowLoader(false);
            if (response.status === 200){
                setIsDirty(false);
                loadBidsToUI(response.data);
                handleOpenDialog('Submit/Update was successful!', 'A record has been sent to your email', 'Ok');
            } else {
                handleOpenDialog('Error', response.data, 'Ok');
            }
        }).catch((error) => {
            console.log('ERROR', error);
            setShowLoader(false);
            handleOpenDialog('An error occurred', '', 'Ok');
        });
    };

    const loadBidsToUI = (bids) => {
        let vac1 = [];
        let vac2 = [];
        let vac3 = [];
        let vac4 = [];
        let vac5 = [];
        _each(bids, function(bid) {
            const temp = {
                id: bid.id,
                rank: bid.bidRank,
                inclusiveEndDate: commonFunctions.formatDate_Date(bid.inclusiveEndDate),
                startDate: commonFunctions.formatDate_Date(bid.startDate),
                numOfVacDays: commonFunctions.calculateNumberOfDays(bid.startDate, bid.inclusiveEndDate),
                vacationNumber: bid.vacationNumber,
                bidSubmittedTime: commonFunctions.formatDate_DateTime24(bid.bidSubmittedTime)
            }
            switch(bid.vacationNumber) {
                case 1:
                    vac1.splice(bid.rank - 1, 0, temp);
                    break;
                case 2:
                    vac2.splice(bid.rank - 1, 0, temp);
                    break;
                case 3:
                    vac3.splice(bid.rank - 1, 0, temp);
                    break;
                case 4:
                    vac4.splice(bid.rank - 1, 0, temp);
                    break;
                case 5:
                    vac5.splice(bid.rank - 1, 0, temp);
                    break;
                default:
                    break;
            };
        });
        setVacation1(_sortBy(vac1, ['rank']));
        setVacation2(_sortBy(vac2, ['rank']));
        setVacation3(_sortBy(vac3, ['rank']));
        setVacation4(_sortBy(vac4, ['rank']));
        setVacation5(_sortBy(vac5, ['rank']));
    };

    return (
        <YearlyProvider biddingClosed={biddingClosed}>
        <Prompt
            when={isDirty}
            message={isDirtyMessage}
          />
        <Card className={classes.card}>
            <CardContent>
                <div className={classes.title}>
                    <span>Yearly Vacation Bids {biddingYear}</span>
                    {((biddingClosed || freezeBidding) && <span className={classes.closed}>Bidding is Closed</span>) || <CountdownTimer className={classes.closed} endDateTimeMoment={endTimeMoment} onTimerComplete={handleTimerComplete}/>}
                </div>
                <Disclaimer />
                <EmployeeInformation
                    name={name}
                    employeeId={employeeId}
                    seniorityDate={seniorityDate}
                    domicile={domicile}
                />
                <BidInformation
                    group={group}
                    periodsBidding={periodsBidding}
                    daysToBid={daysToBid}
                />
                <div className={classes.marginBottom}></div>

                {periodsBidding > 0 &&
                <VacationInformation
                    vacation={vacation1}
                    vacationNumber={1}
                    daysToBid={daysToBid}
                    isUpdating={isUpdating}
                    freezeBidding={freezeBidding}
                    handleYearlyVacAdd={handleYearlyVacAdd}
                    handleYearlyVacRemove={handleYearlyVacRemove}
                    slotsAvailable={slotsAvailable}
                    handleYearlyVacReorder={handleYearlyVacReorder}
                />}
                {periodsBidding > 1 &&
                <VacationInformation
                    vacation={vacation2}
                    vacationNumber={2}
                    daysToBid={daysToBid}
                    isUpdating={isUpdating}
                    freezeBidding={freezeBidding}
                    handleYearlyVacAdd={handleYearlyVacAdd}
                    handleYearlyVacRemove={handleYearlyVacRemove}
                    slotsAvailable={slotsAvailable}
                    handleYearlyVacReorder={handleYearlyVacReorder}
                />}
                {periodsBidding > 2 &&
                <VacationInformation
                    vacation={vacation3}
                    vacationNumber={3}
                    daysToBid={daysToBid}
                    isUpdating={isUpdating}
                    freezeBidding={freezeBidding}
                    handleYearlyVacAdd={handleYearlyVacAdd}
                    handleYearlyVacRemove={handleYearlyVacRemove}
                    slotsAvailable={slotsAvailable}
                    handleYearlyVacReorder={handleYearlyVacReorder}
                />}
                {periodsBidding > 3 &&
                <VacationInformation
                    vacation={vacation4}
                    vacationNumber={4}
                    daysToBid={daysToBid}
                    isUpdating={isUpdating}
                    freezeBidding={freezeBidding}
                    handleYearlyVacAdd={handleYearlyVacAdd}
                    handleYearlyVacRemove={handleYearlyVacRemove}
                    slotsAvailable={slotsAvailable}
                    handleYearlyVacReorder={handleYearlyVacReorder}
                />}
                {periodsBidding > 4 &&
                <VacationInformation
                    vacation={vacation5}
                    vacationNumber={5}
                    daysToBid={daysToBid}
                    isUpdating={isUpdating}
                    freezeBidding={freezeBidding}
                    handleYearlyVacAdd={handleYearlyVacAdd}
                    handleYearlyVacRemove={handleYearlyVacRemove}
                    slotsAvailable={slotsAvailable}
                    handleYearlyVacReorder={handleYearlyVacReorder}
                />}

                {!freezeBidding &&
                    <>
                    <Divider className={classes.divider} />
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {!biddingClosed &&
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<PublishIcon />}
                                onClick={handleSaveClick}
                            >
                                Submit
                            </Button>}
                        </Grid>
                    </Grid>
                    </>
                }
            </CardContent>
        </Card>

        <Dialog
            open={openSaveDialog}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Submit/Update the form data?</DialogTitle>
            <DialogActions>
                <Button onClick={handleClose_SaveDialog} color="primary">
                    Exit
                </Button>
                <Button onClick={handleSave} color="primary" autoFocus>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openDialog}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>{dialogTitle}</DialogTitle>
            {dialogMessage !== '' &&
            <DialogContent dividers>
                <Typography gutterBottom>
                    {dialogMessage}
                </Typography>
            </DialogContent>}
            <DialogActions>
                <Button onClick={handleCloseDialog} color="primary" autoFocus>
                    {dialogButtonText}
                </Button>
            </DialogActions>
        </Dialog>
        
        {showLoader && <CircularProgress className={classes.loader} />}

        </YearlyProvider>
       )
}

export default Yearly;